angular.module('tgaAdmin').controller('TermsAndConditionsModalController', [
  '$scope',
  '$uibModalInstance',
  '$uibModalStack',
  'extras',
  'userService',
  'supportService',
  function ($scope, $uibModalInstance, $uibModalStack, extras, userService, supportService) {
    $scope.data = {
      agreement: extras.agreement,
      alerts: [],
      closeButton: true,
    };

    $scope.viewmodel = {
      userAcceptedAgreement: false,
    };

    $scope.initialize = function () {};

    $scope.actions = {
      submit() {
        supportService
          .storeUserAgreements($scope.data.agreement.agreement_id, userService.getUserData().id)
          .then(() => {
            $uibModalInstance.close();
          })
          .catch((error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error! </strong> ${error.message}`,
              'danger',
            );
          });
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
